import axios from "axios";

const api = axios.create({
  baseURL: "https://api.teamee.de/api",
  withCredentials: true,
});

export default api;
